import React from 'react';
import './PinPage.css';

const PinPage: React.FC = () => {
  const pins = [
    {
      title: 'Olympics Pin',
      image: '/img/pins/olympics-pin.png'
    },
    {
      title: 'Football Pin',
      image: '/img/pins/football-pin.jpg'
    },
    {
      title: 'Korea Pin',
      image: '/img/pins/korea-pin.jpg'
    },
    {
      title: 'Brazil Pin',
      image: '/img/pins/brazil-pin.png'
    },
    {
      title: 'Russia Pin',
      image: '/img/pins/russia-pin.jpg'
    }
  ];

  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <h1 className="text-center mb-5">The Pin</h1>
          
          {/* Video Section */}
          <section className="video-section mb-5">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h3 className="text-center mb-4">Learn More About Our Pins</h3>
                <p className="text-center text-muted mb-4">
                  Watch this video to understand the purpose and meaning behind our ministry pins
                </p>
                <div className="video-container">
                  <video 
                    controls 
                    className="w-100 rounded shadow"
                    poster=""
                    preload="metadata"
                  >
                    <source src="http://www.attendtheobp.com/uploads/b/9741922-651807231126215280/pin_explantion_475.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </section>
          
          <section className="mb-5">
            <h2 className="mb-4">What is the Pin?</h2>
            <p className="lead">
              The Outreach Bible Project uses specially designed pins as evangelistic tools and conversation starters. 
              These pins are distributed at major sporting events and serve as a bridge to sharing the Gospel message 
              in a natural, non-threatening way.
            </p>
            <p>
              Each pin is carefully designed to be visually appealing and relevant to the specific event or location 
              where it will be distributed. The pins create opportunities for meaningful conversations about faith 
              and provide a memorable keepsake that recipients can treasure long after the event.
            </p>
          </section>

          <section className="pin-showcase">
            <div className="row g-4">
              {pins.map((pin, index) => (
                <div key={index} className="col-md-6">
                  <div className="pin-card">
                    <h3>{pin.title}</h3>
                    <div className="pin-image-container">
                      <img 
                        src={pin.image} 
                        alt={pin.title} 
                        className="pin-image"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="pin-explanation mt-5">
            <h3 className="text-center mb-4">Pin Explanation</h3>
            <p className="text-center text-muted mb-4">
              Understanding the colors and symbols on our pins helps explain the Gospel message
            </p>
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="explanation-image-container">
                  <img 
                    src="/img/football-wordless-explanation-card.png" 
                    alt="Pin Color Explanation - Gospel Message through Colors"
                    className="explanation-image w-100 rounded shadow"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="mt-5 text-center">
            <h3>Using Pins for Evangelism</h3>
            <p className="lead">
              These pins serve as natural conversation starters, allowing our volunteers to engage 
              in meaningful discussions about faith in a comfortable, non-confrontational way.
            </p>
            <div className="row mt-4">
              <div className="col-md-4">
                <div className="feature-box">
                  <i className="fas fa-handshake fs-2 text-primary mb-3"></i>
                  <h5>Ice Breaker</h5>
                  <p>Pins create natural opportunities to start conversations with strangers.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature-box">
                  <i className="fas fa-heart fs-2 text-danger mb-3"></i>
                  <h5>Memorable Gift</h5>
                  <p>Recipients often keep the pins as meaningful mementos of their encounter.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature-box">
                  <i className="fas fa-cross fs-2 text-warning mb-3"></i>
                  <h5>Gospel Message</h5>
                  <p>Each pin design incorporates Christian symbolism and Gospel themes.</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PinPage;
